import i18next from 'i18next';

export const TYPE_OF_WASTE_RATE = {
  BY_STORE: 'by_store',
  BY_PRODUCT: 'by_product',
};

const getProductLossStockConvention = () => [
  { id: 'before_opening', name: i18next.t('STOCKS.STOCKS.FORM_HEADER_CONVENTION_START_DISPLAY') },
  { id: 'after_closing', name: i18next.t('STOCKS.STOCKS.FORM_HEADER_CONVENTION_END_DISPLAY') },
];

const getTypeOfWasteRate = (translatedStoreName) => [
  {
    id: TYPE_OF_WASTE_RATE.BY_STORE,
    name: i18next.t('BACKOFFICE.STORES.WASTE_RATE_BY_STORE_NAME', {
      storeName: translatedStoreName,
    }),
  },
  { id: TYPE_OF_WASTE_RATE.BY_PRODUCT, name: i18next.t('BACKOFFICE.STORES.WASTE_RATE_BY_PRODUCT') },
];

const getStoreProductionCardSettings = (
  storeProduction,
  isKitchenStoreForm,
  translatedStoreName,
) => {
  const inputs = [
    {
      dropdownValue: getProductLossStockConvention(),
      hasTooltip: true,
      isDropdown: true,
      isSearchDisabled: true,
      dropdownMatchingProperty: 'id',
      isRequired: !isKitchenStoreForm, // Required if creating "point of sale" type store
      isSwitch: false,
      isMultipleChoice: false,
      icon: 'none',
      emptyIcon: 'none',
      iconWidth: 0,
      label: i18next.t('GENERAL.STOCK_CONVENTION'),
      placeholder: i18next.t('GENERAL.CHOOSE_PLACEHOLDER'),
      propertyKey: 'productionStockConvention',
      type: 'dropdown',
      customZIndex: '4',
      tooltipText: i18next.t('GENERAL.STOCK_CONVENTION_PRODUCTION'),
    },
    {
      dropdownValue: getProductLossStockConvention(),
      hasTooltip: true,
      isDropdown: true,
      isSearchDisabled: true,
      dropdownMatchingProperty: 'id',
      isRequired: !isKitchenStoreForm, // Required if creating "point of sale" type store
      isSwitch: false,
      isMultipleChoice: false,
      icon: 'none',
      emptyIcon: 'none',
      iconWidth: 0,
      label: i18next.t('GENERAL.LOSS_CONVENTION'),
      placeholder: i18next.t('GENERAL.CHOOSE_PLACEHOLDER'),
      propertyKey: 'productionLossConvention',
      type: 'dropdown',
      customZIndex: '4',
      tooltipText: i18next.t('GENERAL.LOSS_CONVENTION_PRODUCTION'),
    },
    {
      dropdownValue: getTypeOfWasteRate(translatedStoreName),
      isDropdown: true,
      isSearchDisabled: true,
      isRequired: false,
      dropdownMatchingProperty: 'id',
      isSwitch: false,
      isMultipleChoice: false,
      icon: 'none',
      emptyIcon: 'none',
      iconWidth: 0,
      label: i18next.t('BACKOFFICE.STORES.WASTE_RATE_TYPE'),
      placeholder: i18next.t('BACKOFFICE.STORES.WASTE_RATE_TYPE'),
      propertyKey: 'typeOfWasteRate',
      type: 'dropdown',
    },
    {
      hasTooltip: true,
      emptyIcon: 'none',
      isDropdown: false,
      isRequired: false,
      readOnly: storeProduction.typeOfWasteRate === TYPE_OF_WASTE_RATE.BY_PRODUCT,
      label: i18next.t('BACKOFFICE.STORES.CREATION_MODAL_CARD_PRODUCTION_PROD_WASTE_RATE'),
      placeholder:
        storeProduction.typeOfWasteRate === TYPE_OF_WASTE_RATE.BY_PRODUCT
          ? i18next.t('BACKOFFICE.STORES.DEFINE_WASTE_RATE_BY_PRODUCT')
          : i18next.t('BACKOFFICE.STORES.CREATION_MODAL_CARD_PRODUCTION_PROD_WASTE_RATE'),
      propertyKey: 'targetProductionWasteRate',
      type: 'number',
      tooltipText: i18next.t(
        'BACKOFFICE.STORES.CREATION_MODAL_CARD_PRODUCTION_PROD_WASTE_RATE_TOOLTIP',
      ),
    },
  ];

  return {
    title: i18next.t('BACKOFFICE.STORES.CREATION_MODAL_CARD_PRODUCTION_TITLE'),
    inputs: inputs.reduce((acc, input) => {
      if (
        input.propertyKey === 'targetProductionWasteRate' &&
        storeProduction.typeOfWasteRate === TYPE_OF_WASTE_RATE.BY_PRODUCT
      ) {
        acc.push({ ...input, value: null });
        return acc;
      }

      acc.push({ ...input, value: storeProduction[input.propertyKey] });

      return acc;
    }, []),
  };
};

export default getStoreProductionCardSettings;
